module.exports = __webpack_public_path__ + "img/柳川空拍.77757632.jpg";